import styled from 'styled-components';

export const Picture = styled.div`
  margin-left: ${({ theme }) => theme.spacing.km4};
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    margin-right: ${({ theme }) => theme.spacing.km3};
  }
`;

export const Avatar = styled.img`
  object-fit: cover;
  border-radius: ${({ theme }) => theme.border.radius.circle};
  height: 48px;
  width: 48px;
  max-height: 48px;
  max-width: 48px;
`;

export const NoAvatar = styled.div`
  border-radius: ${({ theme }) => theme.border.radius.circle};
  background-color: ${({ theme }) => theme.color.background.neutral.strong};
  color: ${({ theme }) => theme.color.icon.neutral.strong};
  height: 48px;
  width: 48px;
  max-height: 48px;
  max-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
`;

export const LockIconWrapper = styled.span`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${({ theme }) => theme.color.icon.neutral.default};
`;
